// extracted by mini-css-extract-plugin
export default {"socials_wrapper":"SocialIcons_socials_wrapper__elMQH","icon":"SocialIcons_icon__gsoR9"};